import { mapActions, mapState } from 'vuex'
import formButton from '@/components/common/form-button/form-button.vue'
import templateEdit from '@/components/pages/main-pages/settings/templates/template-edit/template-edit.vue'

export default {
  components: {
    formButton
  },
  data() {
    return {
      columns: ['id', 'name', 'age', 'mechanic_name', 'language', 'preparation_time', 'design_type', 'edit']
    }
  },
  computed: {
    ...mapState('template', ['templatesPerPage', 'ageOptions']),
    ...mapState('competitionMechanic', ['mechanicList']),
    ...mapState('workflow', ['workflowList']),
    options: function () {
      return {
        filterable: false,
        headings: {
          name: 'Name',
          edit: ' ',
          preparation_time: 'Preparation time [days]'
        },
        perPage: 6,
        orderBy: {
          column: 'name'
        },
        requestFunction: function (data) {
          return this.searchTemplates({ offset: (data.page - 1) * this.templatesPerPage })
        }.bind(this),
        responseAdapter: function (resp) {
          var data = this.getResponseData(resp)
          data.data.forEach((template) => {
            template.edit = this.toggleChildRow
            template.refresh = this.refresh
          })
          return {
            data: data.data,
            count: data.total
          }
        },
        childRow: templateEdit
      }
    }
  },
  methods: {
    ...mapActions('template', ['searchTemplates']),
    ...mapActions('competitionMechanic', ['getMechanicList']),
    ...mapActions('workflow', ['getWorkflowsList']),
    getAgeTitle: function (ageName) {
      return this.ageOptions.filter((age) => age.name === ageName)[0].title
    },
    toggleEditRow: function (id) {
      this.$refs.templates_table.toggleChildRow(id)
    }
  },
  async created() {
    if (this.mechanicList.length === 0) {
      try {
        await this.getMechanicList()
      } catch (e) {
        throw e.response
      }
    }
    if (this.workflowList.length === 0) {
      try {
        await this.getWorkflowsList({})
      } catch (e) {
        throw e.response
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/pages/main-pages/settings/templates/templates-list/templates-list.js